import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_ALL',
    'FETCH_SUCCESS',
    'RESET_TO_INITIAL_STATE'
], 'ACTIVITIES');


// Action Creators
export const fetchActivities = createAction(actions.FETCH_ALL, params => params);
export const fetchActivitiesSuccess = createAction(actions.FETCH_SUCCESS, data => data);
export const resetActivitiesInitialState = createAction(actions.RESET_TO_INITIAL_STATE);

// Reducers
const initialState = {
    keys: null,
    data: null,
    xAxisLabel: null,
    rankings: null,
    categories: null,
    apiConfig: null,
    hasData: null,
    display: {},
    mobile: {},
    native: {},
    video: {},
    tv: {},
    site: {},
    youtube: {},
    audio: {}
};

export default handleActions({

    [actions.FETCH_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const rootState = action.getState();
            const scopeKey = action.payload.categories.config.selector;
            const data = {};
            action.payload.activities.forEach((activity) => {
                data[activity] = {
                    statistics: action.payload[activity].statistics,
                    items: action.payload[activity][scopeKey],
                    channelBreakdown: action.payload[activity].channelBreakdown
                };
            });


            const updatedData = {
                keys: { $set: action.payload.activities },
                hasData: { $set: hasData },
                data: { $set: data },
                rankings: { $set: action.payload.rankings },
                categories: { $set: action.payload.categories[scopeKey] },
                xAxisLabel: { $set: action.payload.categories.config.xAxisLabel },
                apiConfig: { $set: rootState.config.selectedTimeRange.apiConfig }
            };

            if (action.payload.params.tactic) {
                return update(state, {
                    [action.payload.params.tactic]: updatedData
                });
            }

            return update(state, updatedData);
        }

        const updatedData = {
            hasData: { $set: hasData }
        };

        if (action.payload.params.tactic) {
            return update(state, {
                [action.payload.params.tactic]: updatedData
            });
        }

        return update(state, updatedData);
    },

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/activities/duck.js